import React from "react";
import Footer from "../../../components/Footer";

const Healthcare = () => {
  return (
    <section className="bg-white pt-20">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        {/* LEFT CONTENT */}
        <div className="px-6 sm:px-10 lg:px-16 py-12 lg:flex lg:items-center">
          <div>
            <p className="text-sm font-semibold text-gray-600 mb-3">
              Industries →
            </p>

            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              Cybersecurity for Healthcare
            </h1>

            <p className="font-semibold text-gray-800 mb-6">
              Cyberattacks on healthcare more than doubled between 2016 and
              2021, exposing the PHI of 42 million people, with ransomware
              continuing to rise—up 30% by 2025—across hospitals, vendors, and
              healthcare tech firms.
            </p>

            <p className="text-gray-600 mb-5 leading-relaxed">
              Major incidents like the 2024 Change Healthcare ransomware attack
              affecting 193 million records and Ascension’s outage across 142
              hospitals show how legacy systems are exploited, leading to data
              theft, extortion, and disruptions in patient care.
            </p>

            <p className="text-gray-600 mb-5 leading-relaxed">
              Healthcare organizations operate complex and outdated IT
              environments while facing phishing attacks, third-party vendor
              risks, staff shortages, and tightening regulatory requirements.
            </p>

            <p className="text-gray-600 mb-8 leading-relaxed">
              In 2024 alone, HIPAA fines reached $36 million—highlighting the
              financial and reputational impact of weak cybersecurity and poor
              risk management.
            </p>

            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              How can Synthera help?
            </h3>

            <ul className="space-y-4 mb-8">
              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  <strong>Risk-Based Compliance (HIPAA & Beyond):</strong> We go
                  beyond checkbox audits by aligning your controls with NIST and
                  HITECH frameworks, ensuring PHI is encrypted at rest and in
                  transit while simplifying regulatory reporting.
                </p>
              </li>

              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  <strong>IoMT & Medical Device Security:</strong> We provide
                  full visibility into connected medical devices and implement
                  micro-segmentation so a compromised device can’t impact
                  critical clinical systems.
                </p>
              </li>

              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  <strong>Legacy System Hardening:</strong> When systems can’t
                  be replaced, we apply virtual patching and hardened perimeters
                  to protect critical assets from modern exploits.
                </p>
              </li>

              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  <strong>Operational Resilience & Recovery:</strong> We design
                  and test offline clinical workflows and air-gapped backups so
                  care delivery continues—even during a cyber incident.
                </p>
              </li>
            </ul>

            <p className="text-gray-700 font-semibold mb-8">
              Our goal is to move your organization from reactive defense to
              proactive resilience—making cybersecurity a core pillar of patient
              safety.
            </p>

            {/* COOL LINK CTA */}
            <a
              href="/Contact"
              className="group inline-flex items-center gap-1 font-semibold text-green-700 hover:text-green-800 transition"
            >
              <span className="relative">
                Talk to an expert
                <span className="absolute left-0 -bottom-0.5 h-0.5 w-0 bg-green-700 transition-all duration-300 group-hover:w-full"></span>
              </span>
              <span className="transition-transform duration-300 group-hover:translate-x-1">
                →
              </span>
            </a>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="relative hidden lg:block pt-10">
          <img
            src="https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1770613556/Healthcare_o1eikj.png"
            alt="Healthcare Cyber Security"
            className="w-full h-full object-cover"
          />

          {/* GREEN OVERLAY — MATCHED WITH IMAGE */}
          {/* <div className="absolute top-10 left-0 right-0 bottom-0 bg-green-900/70"></div> */}
        </div>
      </div>

      <Footer />
    </section>
  );
};

export default Healthcare;
